import * as z from "zod"

export const detailsSchema = z.object({
  program_start_time: z.iso.time({
    precision: -1,
    error: "Please choose a start time for the program",
  }),
  expected_cohort_size: z
    .number({ error: "Please enter how many students are expected" })
    .min(1, "We need at least one student to run the session")
    .max(200, "Please enter a number no greater than 200"),
  booking_manager: z.coerce
    .string<string>()
    .nonempty("Please choose a booking contact"),
})
